// AWS Cognito configuration for react-oidc-context
export const cognitoAuthConfig = {
    authority: import.meta.env.VITE_COGNITO_DOMAIN,  // Use Cognito Hosted UI domain as authority
    client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
    redirect_uri: `${import.meta.env.VITE_REDIRECT_URI}/auth/callback`,
    response_type: "code",
    scope: "email openid phone profile",
    post_logout_redirect_uri: import.meta.env.VITE_REDIRECT_URI,

    automaticSilentRenew: true,
    loadUserInfo: true,

    // Use standard /oauth2/authorize for login
    metadata: {
        issuer: import.meta.env.VITE_COGNITO_DOMAIN,
        authorization_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/oauth2/authorize`,
        token_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/oauth2/token`,
        userinfo_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/oauth2/userInfo`,
        end_session_endpoint: `${import.meta.env.VITE_COGNITO_DOMAIN}/logout`,
        jwks_uri: `${import.meta.env.VITE_COGNITO_DOMAIN}/.well-known/jwks.json`,
    }
};

export const logLevel = 'info';

export const loginRequest = {
    scopes: [`${import.meta.env.VITE_AZURE_CLIENT_ID}/.default`],
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};